import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';
import { Datagrid } from '@zipari/shared-ds-util-datagrid';
import { PortalFooterConfiguration } from '@zipari/shared-ds-util-footer';
import { PaginatorConfiguration } from '../../notes/paginator/paginator.component';
import { checkInputsForText } from '../../design-system.helper';

export interface SidebarTableViewConfiguration {
  sidebar?: {
    label: string;
    attributes: ModelAttributeConfig[];
  };
  datagrid: Datagrid;
  tabs?: object[];
  tabLabels?: string[];
  activeTab?: object;
  filter?: any;
  filters?: any[];
  search?: any;
  paginator?: PaginatorConfiguration;
  backButton?: ButtonConfig;
  footer?: PortalFooterConfiguration;
  iconTypes?: any;
}

export interface SidebarTableViewData {
  title: string;
  sidebar: any;
  datagrid: object[];
}

@Component({
  selector: 'sidebar-table-view',
  templateUrl: './sidebar-table-view.component.html',
  styleUrls: ['./sidebar-table-view.component.scss'],
})
export class SidebarTableViewComponent implements OnInit {
  @Input() configuration: SidebarTableViewConfiguration;
  @Input() data: SidebarTableViewData;

  @Output() actionClicked = new EventEmitter<any>();
  @Output() tabSelected = new EventEmitter<any>();
  @Output() rowSelected = new EventEmitter<any>();
  @Output() pageSelected = new EventEmitter<any>();
  @Output() backButtonClicked = new EventEmitter<any>();

  form = new UntypedFormGroup({});

  ngOnInit() {
    const [configuration, data] = checkInputsForText([
      this.configuration,
      this.data,
    ]);

    this.configuration = configuration as SidebarTableViewConfiguration;
    this.data = data as SidebarTableViewData;

    if (this.configuration.filters) {
      this.configuration.filters.forEach((filter) => {
        this.form.addControl(filter.prop, new UntypedFormControl(null));
      });
    }
  }

  getFilterControl(propName: string): UntypedFormControl {
    return this.form.get(propName) as UntypedFormControl;
  }

  setActiveTab(tab) {
    this.tabSelected.emit(this.configuration.tabs[tab]);
  }

  setActiveRow(row) {
    this.rowSelected.emit(row);
  }

  setCurrentPage(page: number) {
    this.pageSelected.emit(page);
  }

  clickBackButton(destination: string) {
    this.backButtonClicked.emit(destination);
  }

  clickAction(action: { row: object; action: string }) {
    this.actionClicked.emit(action);
  }
}
